export default __webpack_public_path__ + "static/media/Delete-big.3ef23f44.svg";